// console.log('Got to athlete javascript');

import { createAlert } from '../scripts/createAlert';
import Sortable from 'sortablejs';
import FanwordLightbox from '../scripts/lightbox';

function windowIsFoShoLoaded(callback, timeout = 200) {
  let called = false;

  window.addEventListener("load", () => {
    if (!called) {
      called = true;
      callback();
    }
  });

  setTimeout(() => {
    if (!called && document.readyState === 'complete') {
      called = true;
      callback();
    }
  }, timeout);
}

function windowIsFinnaBeUnloaded(callback) {
  let called = false;

  window.addEventListener("unload", () => {
    if (!called) {
      called = true;
      callback();
    }
  });
}

// Your code to run since DOM is loaded and ready
$(function() {
  const isMobile = window.innerWidth <= 768;

  let pageViewStart, pageViewEnd;
  const athlete_id = $("#page-athlete").data('trackable-id')

  windowIsFoShoLoaded(() => {
    // console.log('Window is Fo SHO loaded');
    pageViewStart = new Date();

    $.get(`/athletes/${athlete_id}/recommended?mobile=${isMobile}`, (markup) => {
      $("#recommended-athletes").html(markup);
    });
  });

  windowIsFinnaBeUnloaded(function() {
    // pageViewEnd = new Date();
    // console.log('beforeunload', pageViewStart, pageViewEnd)
    // navigator.sendBeacon('/analytics/visits', JSON.stringify({ visit: { athlete_id, duration: (pageViewEnd - pageViewStart) / 1000 } }))
  })

  $(document).on('ajax:complete', '#claim-form', function(event) {
    if (event.originalEvent.detail[0].status === 409) {
      createAlert('warning', 'This profile has been previously claimed with the given email address. FanWord will reach out shortly.');
      $("#dismiss-claim-message-modal").trigger('click');
      return;
    }

    if (event.originalEvent.detail[0].status === 412) {
      createAlert('warning', 'The email address provided is already in-use. Please use the Reset Password feature to gain access to your profile.');
      $("#dismiss-claim-message-modal").trigger('click');
      return;
    }

    $("#claim-modal-form").removeClass('d-block').addClass('d-none');
    $('#claim-modal-complete').removeClass('d-none').addClass('d-block');
  })

  const claimModal = document.getElementById('claim-modal')
  claimModal && claimModal.addEventListener('hide.bs.modal', function (event) {
    $("#claim-modal-form").removeClass('d-none').addClass('d-block');
    $('#claim-modal-complete').removeClass('d-block').addClass('d-none');
  });

  $(document).on('ajax:complete', '#social-report-form', function(event) {
    const key = JSON.parse(event.originalEvent.detail[0].response).key;

    if (event.originalEvent.detail[0].status === 400) {
      createAlert('warning', 'There was an issue generating this report. Please reach out to us at info@fanword.com for help getting the report downloaded.');
      $("#dismiss-social-report-message-modal").trigger('click');
      return;
    }

    $("#social-report-view-button").attr('href', function() { return $(this).attr('href') + key })

    $("#social-report-modal-form").removeClass('d-block').addClass('d-none');
    $('#social-report-modal-complete').removeClass('d-none').addClass('d-block');
  })

  const socialReportModal = document.getElementById('social-report-modal')
  socialReportModal && socialReportModal.addEventListener('hide.bs.modal', function (event) {
    $("#social-report-modal-form").removeClass('d-none').addClass('d-block');
    $('#social-report-modal-complete').removeClass('d-block').addClass('d-none');
  });

  /* Sortable */
  var sortables = document.querySelectorAll('.sortable');
  sortables.forEach(elm => {
    Sortable.create(elm, {
      draggable: '.list-group-item',
      dataIdAttr: 'data-sortable-id',
      handle: ".sortable-handle",  // Drag handle selector within list items

      // Changed sorting within list
      onUpdate: function (event) {
        // console.log('event', event);
        const listItems = event.target.querySelectorAll('.list-group-item');
        const sortableIds = Array.from(listItems).map(elm => elm.dataset.sortableId)
        $.post('/sortable/reorder', { rails_sortable: sortableIds })
      },
    });
  })
  $('body').on('mouseover', '.sortable .list-group-item', function() {
    $(this).find('.sortable-handle').removeClass('invisible').addClass('visible');
  }).on('mouseout', '.list-group-item', () => {
    $(this).find('.sortable-handle').removeClass('visible').addClass('invisible');
  });

  // mobile navigation toggling
  $("body").on("click", "#mobile-nav li a", function(event) {
    event.preventDefault();

    const parent = event.target.parentElement;
    const target = parent.dataset.target;

    $(`.athlete-profile-section`).removeClass('d-block').addClass('d-none');
    $(`#${target}`).removeClass('d-none').addClass('d-block');

    $("#mobile-nav li.active").removeClass('active');
    $(parent).addClass('active');
  });

  FanwordLightbox.reloadLightbox('glightbox-athlete-images');
})
